import { Card, CardContent, CardHeader, CardTitle } from "@/components/ui/card";
import { Button } from "@/components/ui/button";
import { Users, Car, Phone, Mail, MapPin, Pencil } from "lucide-react";

export const CustomerVehicleCards = ({ customer, vehicle, onEditCustomer, onEditVehicle }) => {
  return (
    <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
      {/* Customer Card */}
      <Card data-testid="detail-customer-card">
        <CardHeader className="pb-3">
          <div className="flex items-center justify-between">
            <CardTitle className="text-base flex items-center gap-2">
              <Users className="w-5 h-5 text-blue-600" />Kunde
            </CardTitle>
            {customer && (
              <Button variant="ghost" size="icon" className="h-8 w-8" onClick={onEditCustomer} data-testid="detail-edit-customer-btn">
                <Pencil className="w-4 h-4" />
              </Button>
            )}
          </div>
        </CardHeader>
        <CardContent className="space-y-2">
          {customer ? (
            <>
              <p className="font-semibold">{customer.first_name} {customer.last_name}</p>
              {customer.street && (
                <p className="text-sm text-muted-foreground flex items-center gap-2">
                  <MapPin className="w-4 h-4" />
                  {customer.street}, {customer.postal_code} {customer.city}
                </p>
              )}
              {customer.phone && (
                <p className="text-sm text-muted-foreground flex items-center gap-2">
                  <Phone className="w-4 h-4" />{customer.phone}
                </p>
              )}
              {customer.email && (
                <p className="text-sm text-muted-foreground flex items-center gap-2">
                  <Mail className="w-4 h-4" />{customer.email}
                </p>
              )}
            </>
          ) : (
            <p className="text-sm text-muted-foreground">Kein Kunde zugewiesen</p>
          )}
        </CardContent>
      </Card>

      {/* Vehicle Card */}
      <Card data-testid="detail-vehicle-card">
        <CardHeader className="pb-3">
          <div className="flex items-center justify-between">
            <CardTitle className="text-base flex items-center gap-2">
              <Car className="w-5 h-5 text-green-600" />Fahrzeug
            </CardTitle>
            {vehicle && (
              <Button variant="ghost" size="icon" className="h-8 w-8" onClick={onEditVehicle} data-testid="detail-edit-vehicle-btn">
                <Pencil className="w-4 h-4" />
              </Button>
            )}
          </div>
        </CardHeader>
        <CardContent className="space-y-2">
          {vehicle ? (
            <>
              <p className="font-semibold">{vehicle.brand} {vehicle.model}</p>
              <p className="text-sm font-mono bg-muted px-2 py-1 rounded inline-block">{vehicle.license_plate}</p>
              <div className="grid grid-cols-2 gap-2 text-sm text-muted-foreground">
                {vehicle.year && <span>Baujahr: {vehicle.year}</span>}
                {vehicle.mileage && <span>KM: {vehicle.mileage.toLocaleString()}</span>}
              </div>
              {vehicle.vin && <p className="text-xs text-muted-foreground">VIN: {vehicle.vin}</p>}
            </>
          ) : (
            <p className="text-sm text-muted-foreground">Kein Fahrzeug zugewiesen</p>
          )}
        </CardContent>
      </Card>
    </div>
  );
};
